export const LIGNE_ROB_STRUCT_RESET = "LIGNE_ROB_STRUCT_RESET";
export const LIGNE_ROB_STRUCT_SET_ERROR = "LIGNE_ROB_STRUCT_SET_ERROR";
export const LIGNE_ROB_STRUCT_SET_ITEMS = "LIGNE_ROB_STRUCT_SET_ITEMS";
export const LIGNE_ROB_STRUCT_TOGGLE_LOADING =
  "LIGNE_ROB_STRUCT_TOGGLE_LOADING";
